import * as PIXI from "pixi.js";
import {Assets, Point} from 'pixi.js';
import {gameBackground} from "./components/gameBackground";
import {scaleToWindow} from "./assets/scaleToWindow";
import {Header} from "./components/header/Header";
import {ApiService, app, events, modal, ticker} from "./utils/pixiApp";
import {Footer} from "./components/footer/Footer";
import {Loader} from "./components/Loader";
import TWEEN from "@tweenjs/tween.js";
import {tweenAnimations} from "./utils/tween";
import {PostMessageService, PostMessagesTypes} from "./core/api/postMessageService";
import {checkTokenInterceptor} from "./core/api/axiosInterceptors";
import {Body} from "./components/body/Body";


let type = "WebGL";
if (!PIXI.isWebGLSupported()) {
    type = "canvas";
}


PIXI.sayHello(type);

ApiService.setCredentials({
    URL: process.env.API_URL || '',
});

window.onload = () => {
    PostMessageService.ListenPostMessage(true);
    init();
};


async function init() {
    checkTokenInterceptor();
    PostMessageService.postMessage({
        type: PostMessagesTypes.STARTED_APP
    });

    let width = window.innerWidth < 768 ? Math.max(document.documentElement.clientWidth, window.innerWidth || 0) : 1440;//window.innerWidth < 768 ? window.innerWidth : 1440;
    let height = window.innerWidth < 768 ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : 1024// window.innerWidth < 768 ? window.innerHeight : 900;

    Assets.add([
        { alias: 'preloaderDesktop', src: '../src/assets/img/preloadDesktop.png' },
        { alias: 'preloaderMobile', src: '../src/assets/img/preloadMobile.png' },
    ]);

    await Assets.load(['preloaderDesktop', 'preloaderMobile'])
    await app.init({
        width: width,
        height: height,
        autoResize: true,
        resizeTo: true,
        antialias: true,
        resolution: window.devicePixelRatio || 2,
        autoDensity: true,
        sharedTicker: true,
    }).then(() => {
        const tw = TWEEN;
        ticker.add(() => tw.update())
    });

    document.body.appendChild(app.canvas, '#0c0c0c');
    //scaleToWindow(app.canvas);
    doScaleWindow()
    const c = new PIXI.Container();
    app.stage.addChild(c)
    const loader = new Loader()
    c.addChild(loader)


    window.addEventListener("resize", doScaleWindow);

    Assets.addBundle('fonts', [
        {alias: 'MontserratBold', src: '../src/assets/fonts/Montserrat-Bold.ttf'},
        {alias: 'RubikMedium', src: '../src/assets/fonts/Rubik-Medium.ttf'},
        {alias: 'RubikRegular', src: '../src/assets/fonts/Rubik-Regular.ttf'},
        {alias: 'RubikBold', src: '../src/assets/fonts/Rubik-Bold.ttf'},
    ]);
    await Assets.loadBundle(['fonts'])
    Assets.addBundle(
        'sprite',
        [
            {alias: 'gameSpriteAlias', src: "../src/assets/img/spriteElements.json", data: 'gameSprite'},
            {alias: 'cardSpriteAlias', src: "../src/assets/img/cardSprite.json", data: 'cardSprite'},
            {alias: 'meshAlias', src: "../src/assets/img/mesh2.json", data: 'meshSprite' },
            {alias: 'fireStartAlias', src: "../src/assets/img/fireStart.json", data: 'fireSprite'},
            {alias: 'fireCicleAlias', src: "../src/assets/img/fireCicle.json", data: 'fireCicleSprite'},
            {alias: 'btnSpriteAlias', src: "../src/assets/img/btnSprite.json", data: 'btnSprite'},
            {alias: 'brush', src: "../src/assets/img/brush.png"},
            {alias: 'circleBrush', src: "../src/assets/img/circleBrush.png"}
        ],
    )

    Assets.add({alias: 'Sparks', src: "../src/assets/img/Sparks.png"})
    await Assets.load(['Sparks'])

    await Assets.loadBundle(['sprite'], (progress) => {
        loader.emit('SET_PROGRESS', progress)
    })

    function doScaleWindow() {
        if(window.innerWidth < 768) {
            const canvas = app.renderer.view;
            width = window.innerWidth // Math.max(document.documentElement.clientWidth, window.innerWidth || 0);//window.innerWidth < 768 ? window.innerWidth : 1440;
            height = window.innerHeight //Math.max(document.documentElement.clientHeight, window.innerHeight || 0);// window.innerWidth < 768 ? window.innerHeight : 900;
            canvas.screen.width = width;
            canvas.screen.height = height;
            app.canvas.style.margin = 0;
            app.canvas.style.scale = 1
            app.canvas.style.transform = 'none'
            app.renderer.resize(width, height)
            events.emitScreenResizeEvent({
                width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
            })
        } else {
            app.renderer.resize(1440, 1024)
            events.emitScreenResizeEvent({
                width: 1440,
                height: 1024
            })
            scaleToWindow(app.canvas, '#0c0c0c');
        }
    }

    const startAppVisual = async () => {
        console.log('LOAD')
        app.stage.removeChild(loader)

        const renderTexture = PIXI.RenderTexture.create({width:app.screen.width, height: app.screen.height});
        const renderTextureSprite = new PIXI.Sprite(renderTexture);



        const width = app.screen.width
        const height = app.screen.height
        const lineCenter = height / 4 / 2
        const point = new Point(0,lineCenter);
        const brush = new PIXI.Sprite(PIXI.Texture.from('brush'));
        brush.setSize(width / 3 , height / 3 );
        brush.position.set(-20,-20)
        brush.anchor.set(.5,.5);
        const startAnimCallback = (obj) => {
            brush.rotation = obj.x * Math.PI;
            brush.position.set(obj.x, obj.y);
            app.renderer.render({
                container: brush,
                target: renderTexture,
                clear: false,
            });
            point.set(obj.x, obj.y)
        }
        const startAnim1 = tweenAnimations(
            {x: 0, y: lineCenter},
            {x: width, y: lineCenter},
            160,
            (obj) => {
                startAnimCallback(obj)
            });
        const startAnim2 = tweenAnimations(
            {x: width, y: lineCenter},
            {x: -100, y: height / 4 * 2 - lineCenter},
            160,
            (obj) => {
                startAnimCallback(obj)
            });
        const startAnim3 = tweenAnimations(
            {x: -100, y: height / 4 * 2 - lineCenter},
            {x: width, y: height / 4 * 2 - lineCenter},
            160,
            (obj) => {
                startAnimCallback(obj)
            });
        const startAnim4 = tweenAnimations(
            {x: width, y: height / 4 * 2 - lineCenter},
            {x: -100, y: height / 4 * 3 - lineCenter},
            160,
            (obj) => {
                startAnimCallback(obj)
            });
        const startAnim5 = tweenAnimations(
            {x: -100, y: height / 4 * 3 - lineCenter},
            {x: width, y: height / 4 * 3 - lineCenter},
            160,
            (obj) => {
                startAnimCallback(obj)
            });
        const startAnim6 = tweenAnimations(
            {x: width, y: height / 4 * 3 - lineCenter},
            {x: -100, y: height - lineCenter},
            160,
            (obj) => {
                startAnimCallback(obj)
            });
        const startAnim7 = tweenAnimations(
            {x: -100, y: height - lineCenter},
            {x: width, y: height - lineCenter},
            160,
            (obj) => {
                startAnimCallback(obj)
            });

        startAnim1.chain(startAnim2)
        startAnim3.chain(startAnim4)
        startAnim5.chain(startAnim6)
        startAnim2.onComplete(() => startAnim3.start())
        startAnim4.onComplete(() => startAnim5.start())
        startAnim6.onComplete(() => startAnim7.start())
        startAnim7.onComplete(() => {
            c.mask = null
            app.stage.addChild(modal);
            app.stage.removeChild(renderTextureSprite)
            events.emitLoadApp()
        })
        const c = new PIXI.Container();
        const gameBg = gameBackground();
        const topBar = new Header();
        const body = new Body()
        const footer = new Footer();
        gameBg.forEach(item => {
            c.addChild(item)
        });
        c.addChild(topBar, footer, body);
        c.mask = renderTextureSprite;

        app.stage.addChild(c, renderTextureSprite);
        startAnim1.start()
    }
    // startAppVisual()
    loader.on('END_LOAD', startAppVisual)
}